var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 4.96094L7.99994 8.36759L13.8466 4.98092",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.408V8.36133",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6204 1.65398L3.0604 3.63401C2.25374 4.08067 1.59375 5.20066 1.59375 6.12066V9.88734C1.59375 10.8073 2.25374 11.9273 3.0604 12.374L6.6204 14.354C7.3804 14.774 8.62706 14.774 9.38706 14.354L12.9471 12.374C13.7537 11.9273 14.4137 10.8073 14.4137 9.88734V6.12066C14.4137 5.20066 13.7537 4.08067 12.9471 3.63401L9.38706 1.65398C8.6204 1.22732 7.3804 1.22732 6.6204 1.65398Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3345 8.82577V6.38578L5.00781 2.73242",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.9caa854dd6ab03eea89f21dafb33abf1.svg";
export { ForwardRef as ReactComponent };